export default __webpack_public_path__ + "static/media/tamarac.4113a7fa.jpg";